import { createBrowserHistory } from 'history'

// This is the default history implementation that
// gets passed to React Router. By providing our
// own history object, we're able to control
// the push state implementation that gets used
// in testing. See App.page-object for how this is done.
export const history = createBrowserHistory()
